import {
  SOURCE_KIND_LABELS,
  STATE_LABELS,
} from '../common/components/materials/materialPresentationConstants';

const MATERIAL_PENDING_COST = 'Costo pendiente';
const MILLION = 1000000;
const THOUSAND = 1000;
const VALUE_LABELS_BY_KEY = { source_kind: SOURCE_KIND_LABELS, state: STATE_LABELS };

/** Muestra ausencia de costo sin transformarla en cero. */
export const materialMoney = (value) =>
  value == null
    ? MATERIAL_PENDING_COST
    : new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(value);

/** Formato corto para ejes de gráficos (k / M), igual al de los tableros de Finanzas. */
export const materialCompactMoney = (value) => {
  const number = Number(value || 0);
  const abs = Math.abs(number);
  if (abs >= MILLION) {
    return `$ ${(number / MILLION).toLocaleString('es-AR', { maximumFractionDigits: 1 })} M`;
  }
  if (abs >= THOUSAND) {
    return `$ ${(number / THOUSAND).toLocaleString('es-AR', { maximumFractionDigits: 0 })} k`;
  }
  return materialMoney(number);
};

/** Conserva comparadores sobre datos crudos; el formato solo se aplica al renderizar. */
export const materialCell = (key, value) => {
  if (VALUE_LABELS_BY_KEY[key]) return VALUE_LABELS_BY_KEY[key][value] || value;
  if (
    key.includes('amount')
    || key.includes('cost')
    || key.includes('value_ars')
    || key.includes('price_ars')
  ) {
    return materialMoney(value);
  }
  if (value == null || value === '') return '—';
  if (typeof value === 'number') {
    return new Intl.NumberFormat('es-AR', { maximumFractionDigits: 3 }).format(value);
  }
  return String(value);
};
